<div class="epic-confirmation">
	<div class="epic-confirmation__message">
		<epic-form-field>
			<epic-select
				[isClearVisible]="false"
				[control]="usersForm.formGroup.controls.assigned_to"
				[customSelectedValues]="true">
				<div
					class="epic-select__custom-values"
					selected-values>
					<div class="epic-select__selected">
						{{ usersForm.formGroup.controls.assigned_to.value?.first_name }}
						{{ usersForm.formGroup.controls.assigned_to.value?.last_name }}
					</div>
				</div>
				@for (user of users; track user) {
					<epic-option
						[value]="user"
						[selected]="order?.assigned_to?.id === user.id"
						class="epic_select__option">
						<div class="epic-select__selected">{{ user.first_name }} {{ user.last_name }}</div>
					</epic-option>
				}
			</epic-select>
		</epic-form-field>
	</div>
	<div class="epic-confirmation__actions">
		<epic-button
			[text]="confirmButtonText"
			(onClick)="updateUser()" />
		<epic-button
			[text]="cancelButtonText"
			[isActive]="false"
			(onClick)="cancelUpdateStatus()" />
	</div>
</div>
